import { SegmentKeyList, } from '@zurich/api/contract';
import { createArrayUtils, getInsuranceSegmentKeyPrefix, UnknownType, } from '@zurich/common/utils';
import { deductibleVariantUtils, insuredGoodsUtils, } from './comprehensiveUtils';
import { selectedUnitsUtils } from './selectedUnitsUtils';
const utils = createArrayUtils(SegmentKeyList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:segmentKey', // FIXME: there is actually no translation - this might be confusing?
    createDefaultValue: () => '00.0_XX', // TODO: what would be a good default value here?
});
function isSegmentByPrefix(segment, searchPrefix) {
    const segmentPrefix = getInsuranceSegmentKeyPrefix(segment?.segmentKey ?? undefined);
    return Array.isArray(searchPrefix)
        ? searchPrefix.includes(segmentPrefix ?? '')
        : segmentPrefix === searchPrefix;
}
export const segmentKeyUtils = {
    ...utils,
    isSegmentByPrefix,
    // 01.0_AH => AH
    getTranslatedValue: (value) => value.toString().split('_')?.pop() ?? null,
};
const getSegmentAHRows = (locale, t, segment) => {
    const sumInsured = selectedUnitsUtils
        .getSelectedSelectableUnitByName('01.0_AH_SumInsured', segment)
        ?.limits?.find((value) => value.limitType === 'totalAmount')?.value;
    const exemptionFromMotorTax = segment?.questionnaire?.motorLiability?.exemptionFromMotorTax;
    const rental = selectedUnitsUtils.getSelectedSelectableUnitByName('01.0_AH_rentalCar', segment);
    const foreignPlus = selectedUnitsUtils.getSelectedSelectableUnitByName('01.0_AH_ForeignPlus', segment);
    return [
        {
            label: t('contract:liability.mtplSumInsured'),
            value: locale.formatMoneyAmount(sumInsured),
        },
        exemptionFromMotorTax && {
            label: t('contract:liability.mtplHandicapped'),
            value: t('common:yes'),
        },
        rental && {
            label: t('contract:liability.mtplRentalCar'),
            value: t('common:yes'),
        },
        foreignPlus && {
            label: t('contract:liability.mtplInternationalPlus'),
            value: t('common:yes'),
        },
    ];
};
const getSegmentKaskoRows = (locale, t, segment) => {
    const noDeductibleForNaturalCatastrophe = segment?.questionnaire?.motorCasco?.noDeductibleForNaturalCatastrophe;
    const noDeductiblesForSmallGlasses = segment?.questionnaire?.motorCasco?.noDeductiblesForSmallGlasses;
    const grossNegligence = segment?.questionnaire?.motorCasco?.grossNegligence;
    const insuredGoods = segment?.questionnaire?.motorCasco?.insuredGoods;
    const deductibleVariant = selectedUnitsUtils
        .getSelectedSelectableUnitByName(`${segment?.segmentKey}_Basic`, segment)
        ?.deductibles?.find((value) => value.deductibleType === 'totalAmount')?.deductibleVariant;
    const deductibleValue = selectedUnitsUtils
        .getSelectedSelectableUnitByName(`${segment?.segmentKey}_Basic`, segment)
        ?.deductibles?.find((value) => value.deductibleType === 'totalAmount')?.value;
    return [
        noDeductibleForNaturalCatastrophe && {
            label: t('contract:comprehensive.noDeductibleForNaturalCatastrophe'),
            value: t('common:yes'),
        },
        noDeductiblesForSmallGlasses && {
            label: t('contract:comprehensive.noDeductiblesForSmallGlasses'),
            value: t('common:yes'),
        },
        grossNegligence && {
            label: t('contract:comprehensive.grossNegligence'),
            value: t('common:yes'),
        },
        insuredGoods && {
            label: t('contract:comprehensive.insuredGoods.label'),
            value: insuredGoodsUtils.getTranslatedValue(t, insuredGoods),
        },
        deductibleVariant && {
            label: t('contract:comprehensive.deductibleVariant.label'),
            value: deductibleVariantUtils.getDeductibleVariantTranslation(deductibleVariant, t, noDeductibleForNaturalCatastrophe ?? undefined, isSegmentByPrefix(segment, 'VK')
                ? 'VK'
                : isSegmentByPrefix(segment, 'TK')
                    ? 'TK'
                    : undefined),
        },
        deductibleValue && {
            label: t('contract:comprehensive.deductibleAmount.label'),
            value: locale.formatMoneyAmount(deductibleValue),
        },
    ];
};
const getSegmentIURows = (locale, t, segment) => {
    const passengerPermDisSelectableUnit = selectedUnitsUtils.getSelectedSelectableUnitByName('03.0_IU_PermDisability', segment);
    const passengerDeathSelectableUnit = selectedUnitsUtils.getSelectedSelectableUnitByName('03.0_IU_Death', segment);
    const accidentCostSelectableUnit = selectedUnitsUtils.getSelectedSelectableUnitByName('03.0_IU_AccidentCosts', segment);
    const childBenefitSelectableUnit = selectedUnitsUtils.getSelectedSelectableUnitByName('03.0_IU_ChildBenefit', segment);
    return [
        passengerPermDisSelectableUnit &&
            passengerPermDisSelectableUnit.limits && {
            label: t('contract:passenger.permDisability'),
            value: locale.formatMoneyAmount(passengerPermDisSelectableUnit.limits[0].value),
        },
        passengerDeathSelectableUnit &&
            passengerDeathSelectableUnit.limits && {
            label: t('contract:passenger.death'),
            value: locale.formatMoneyAmount(passengerDeathSelectableUnit.limits[0].value),
        },
        accidentCostSelectableUnit &&
            accidentCostSelectableUnit.limits && {
            label: t('contract:passenger.accidentCosts'),
            value: locale.formatMoneyAmount(accidentCostSelectableUnit.limits[0].value),
        },
        childBenefitSelectableUnit &&
            childBenefitSelectableUnit.limits &&
            childBenefitSelectableUnit.limits.length > 0 && {
            label: t('contract:passenger.childBenefit'),
            value: locale.formatMoneyAmount(childBenefitSelectableUnit.limits[0].value),
        },
    ];
};
export const policySegmentsUtils = {
    getSegmentAHRows,
    getSegmentKaskoRows,
    getSegmentIURows,
};
